module.exports = __webpack_public_path__ + "static/media/Logo_TELUS_en.7d617fbc.png";